/**
 * 금액 표시 — 원화 기준.
 *
 * 더미 데이터 모듈(`data/dummyCards`)에 있던 같은 이름의 헬퍼를 실 데이터 화면이 쓸 수 있게
 * 옮겨온 것. 더미 모듈은 API 연동이 끝나는 대로 사라진다.
 *
 * ⚠ 단위 표기는 i18n(common:currency.krw) 이다 — "원" 은 한국어 낱말이라 영어·일본어
 *   화면에 그대로 두면 통화가 아니라 오타로 읽힌다(en·ja 모두 `₩12,000`).
 *   자릿수 구분(,)은 세 언어가 같아 그룹핑 로케일은 ko-KR 로 고정한다.
 *   React 밖에서도 불리므로 i18n 인스턴스를 직접 쓴다.
 */
import i18n from "../i18n";

export function formatKrw(amount: number): string {
  return i18n.t("currency.krw", { amount: Math.round(amount).toLocaleString("ko-KR") });
}

/** 부호를 붙인 손익 표시 — 0 은 부호 없이. */
export function formatSignedKrw(amount: number): string {
  const rounded = Math.round(amount);
  if (rounded === 0) return formatKrw(0);
  return `${rounded > 0 ? "+" : "-"}${formatKrw(Math.abs(rounded))}`;
}
